import * as _ from 'lodash';
import { QuotesHttpService } from '../quotes-http.service';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../../../shared/services/auth.service';

declare const $: any;
let self: any;

@Component({
  selector: 'app-quotes-pdf-modal',
  templateUrl: './quotes-pdf-modal.component.html',
  styleUrls: ['./quotes-pdf-modal.component.css']
})
export class QuotesPDFModalComponent implements OnInit {
  document: any | string;
  dialog: MatDialogRef<any>;
  isDev!: boolean;
  src!: any;
  fileNameDownload: string = '';

  constructor(
    private _QuotesService: QuotesHttpService,
    public dialogRef: MatDialogRef<any>,
    private _AuthService: AuthService,
  ) {
    self = this;
    this.dialog = dialogRef;
  }

  ngOnInit() {
    this.isDev = this._AuthService.isRole('dev');
    this.loadPDF();
  }

  async loadPDF(): Promise<void> {
    let numberQuote = this.document?.number.toString().padStart(5, '0');
    let nameClietQuote = this.document?.client.firstname;
    nameClietQuote = this.document?.client.lastname ? nameClietQuote + " " + this.document?.client.lastname : nameClietQuote;
    let dueDate = this.document?.dueDate.split('T')[0] ;

    this.fileNameDownload = 'Presupuesto ' + numberQuote + ' de ' + this._AuthService.company().name + ' - Vto. ' + dueDate + '.pdf'

    const id = (typeof this.document == 'string') ? this.document : this.document._id;
    const file = await this._QuotesService.getQuotePDF(id);
    this.src = file;
  }
}